import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import AddBook from "./pages/AddBook";
import EditBook from "./pages/EditBook";
import Home from "./pages/Home";

function App() {
    return (
        <BrowserRouter>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/addbook" element={<AddBook />} />
                <Route path="/editbook/:id" element={<EditBook />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
